import type { ComponentPropsWithoutRef } from 'react'

const ConditionParagraph = ({ className = '', ...props }: ComponentPropsWithoutRef<'div'>) => <div className={`mt-2.5 ${className}`} {...props} />

export default ConditionParagraph
